import Link from 'next/link';
import { LoginArea } from '@quicktools/shared-components/components/common/Login';

import AppLogo from '../AppLogo';
import { getHeaderLink } from '../../../utils/common/category';
import analytics from '../../../services/analytics';

import useStyles from './styles';
import { IHeader } from './types';

function Header({ handleToggleMenu, icon: Icon, category, hasLogin = true }: IHeader) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Icon className={classes.icon} onClick={handleToggleMenu} />
      <Link href={getHeaderLink(category)} passHref>
        <span className={classes.logo}>
          <AppLogo />
        </span>
      </Link>
      {hasLogin && <LoginArea analytics={analytics} loginButtonFullWidth showName />}
    </div>
  );
}

export default Header;
